<template>
  <div class="app-main">
    <header class="app-header">
      <img :src="logo" class="logo" />
      <div class="label-list">
        <div
          v-for="(item, index) in lableList"
          :key="index"
          class="header-label"
        >
          <router-link
            class="label-link"
            :class="index === 3 || index === 1 ? 'fixedW' : 'fixedO'"
            :style="{ 'margin-right': index === 0 ? '12px' : '30px' }"
            :to="item.to"
            @click="beActive(item.value)"
          >
            <label :class="isActive === item.value ? 'active-color' : ''">{{
              item.label
            }}</label>
            <img
              class="select-img"
              v-show="isActive === item.value"
              :src="selected"
            />
          </router-link>
        </div>
        <div class="select-lang">
          <el-dropdown trigger="click" @command="langChange">
            <span class="el-dropdown-link">
              <img class="flag" :src="currentFlag()" />{{ label
              }}<i class="el-icon-caret-bottom el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="item in langs"
                :command="item.lang"
                :key="item.lang"
              >
                <img class="flag" :src="item.flag" />
                {{ item.label }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <el-select
            v-model="$i18n.locale"
            class="lang"
            prefix-icon="el-icon-caret-bottom"
            @change="langChange"
          >
            <el-option
              v-for="item in langs"
              :key="item.value"
              :label="item.label"
              :value="item.lang"
            >
              <img class="flag" :src="item.flag" />
              <span style="float: right">{{ item.label }}</span>
            </el-option>
            <template #prefix>
              <img class="flag" :src="currentFlag()" />
            </template>
          </el-select> -->
          <div></div>
        </div>
      </div>
    </header>
    <!-- <router-link to="/">setup</router-link>
    |<router-link to="/other">other</router-link> |<router-link to="/vuex"
      >vuex</router-link
    >
    |<router-link to="/jsx">jsx</router-link> |<router-link to="/mock"
      >mock</router-link
    > -->
    <!-- <router-view
      v-if="$route.name == 'other'"
      msg="传递给子组件"
      @myclick="func1"
    ></router-view> -->
    <router-view></router-view>
  </div>
</template>


<script>
import logo from "./assets/img/logo.png";
import selected from "./assets/img/selected.png";
import chinese from "./assets/img/chinese.png";
import us from "./assets/img/us.png";
import list from "./assets/img/list.png";
export default {
  name: "app",
  data() {
    return {
      selected,
      logo,
      list,
      label: "",
      isActive: "",
      langs: [
        {
          lang: "zh-CN",
          label: "简体中文",
          flag: chinese,
        },
        {
          lang: "en-US",
          label: "English",
          flag: us,
        },
      ],
    };
  },
  computed: {
    lableList() {
      return [
        { label: this.$t("hometab"), value: "home", to: "/" },
        { label: this.$t("aboutUstab"), value: "aboutUs", to: "/aboutUs" },
        { label: this.$t("featuretab"), value: "future", to: "/future" },
        { label: this.$t("contacttab"), value: "contact", to: "/contact" },
      ];
    },
  },
  methods: {
    cbeActive(name) {
      this.isActive = name;
    },
    currentFlag() {
      return this.$i18n.locale.split("-")[0].toLowerCase() === "zh"
        ? this.langs[0].flag
        : this.langs[1].flag;
    },
    //语言切换
    langChange(v) {
      const langss = this.langs.find((ele) => ele.lang === v);
      const lang = langss.lang;
      this.label = langss.label;
      this.$i18n.locale = lang;
    },
  },
  mounted() {
    setTimeout(() => {
      this.isActive = this.$route.name;
    }, 0);
    // let lan = navigator.systemLanguage || navigator.language;
    this.langChange("en-US");
  },
  watch: {
    $route: {
      handler: function (curr) {
        this.isActive = curr.name;
      },
    },
  },
};
</script>
<style lang="less" scope>
.app-main {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.app-header {
  position: fixed;
  top: 0;
  width: 1440px;
  background-color: #fff;
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 calc((100vw - 1440px) / 2);

  .logo {
    width: 200px;
    height: 38px;
  }
  .active-color {
    color: #2a358e;
  }
  .label-list {
    display: flex;
    align-items: baseline;
    .flag {
      width: 20px;
      height: 14px;
      margin-right: 8px;
    }

    .el-dropdown {
      font-size: 16px !important;
      font-weight: bold;
      color: #646a73;
      width: 150px;
      line-height: 26px;
      cursor: pointer;
      .el-icon--right {
        margin-left: 5px;
        font-size: 18px;
        color: rgba(100, 106, 115, 1);
      }
    }
    .lang {
      .el-input__inner {
        border: 0;
        font-size: 16px;
        font-family: Microsoft YaHei UI-Bold, Microsoft YaHei UI;
        font-weight: bold;
        color: #646a73;
        width: 150px;
        padding-left: 45px;
        height: 26px;
      }
      .el-input__prefix {
        top: 5px;
      }
      .el-input__suffix {
        height: 52px;
        top: -15px;
      }
    }
  }
  .header-label {
    font-size: 16px;
    line-height: 26px;
    font-family: Arial-Bold, Arial;
    font-weight: bold;
    .fixedW {
      width: 116px;
    }
    .fixedO {
      width: 82px;
    }
    .label-link {
      color: #646a73;
      display: flex;
      margin-right: 20px;
      flex-direction: column;
      align-items: center;
      text-decoration: none;

      label {
        cursor: pointer;
        min-width: 52.32px;
      }
      .select-img {
        width: 52.32px;
        height: 12px;
        cursor: pointer;
      }
    }
    .last {
      margin-right: 0;
    }
  }
}
.app-footer {
  width: 100%;
  background-color: #242933;
  height: 80px;
  line-height: 80px;
  margin: 0 auto;
  font-size: 16px;
  font-family: Arial-Regular, Arial;
  font-weight: 400;
  color: #999999;
}
.fadeIn {
  -webkit-animation: bannerL 1s 0.3s ease both;
  -moz-animation: bannerL 1s 0.3s ease both;
}
@-webkit-keyframes bannerL {
  0% {
    opacity: 0;
    -webkit-transform: translateY(20px);
  }
  100% {
    opacity: 1;
    -webkit-transform: translateY(0);
  }
}
@-moz-keyframes bannerL {
  0% {
    opacity: 0;
    -moz-transform: translateY(20px);
  }
  100% {
    opacity: 1;
    -moz-transform: translateY(0);
  }
}
.fromTop {
  -webkit-animation: fadeInTop 1s 0.2s ease both;
  -moz-animation: fadeInTop 1s 0.2s ease both;
}
@-webkit-keyframes fadeInTop {
  0% {
    opacity: 0;
    -webkit-transform: translateY(-30px);
  }
  100% {
    opacity: 1;
    -webkit-transform: translateY(0px);
  }
}
@-moz-keyframes fadeInTop {
  0% {
    opacity: 0;
    -webkit-transform: translateY(-30px);
  }
  60% {
    -webkit-transform: scaleX(0.5);
  }
  100% {
    opacity: 1;
    -webkit-transform: translateY(0px);
  }
}
.fromLeft {
  -webkit-animation: fadeInLeft 1s 0.2s ease both;
  -moz-animation: fadeInLeft 1s 0.2s ease both;
}
@-webkit-keyframes fadeInLeft {
  0% {
    opacity: 0;
    -webkit-transform: translate(30px);
  }
  100% {
    opacity: 1;
    -webkit-transform: translate(0px);
  }
}
@-moz-keyframes fadeInLeft {
  0% {
    opacity: 0;
    -webkit-transform: translate(30px);
  }
  60% {
    -webkit-transform: scaleX(0.5);
  }
  100% {
    opacity: 1;
    -webkit-transform: translate(0px);
  }
}
</style>
